import React from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import { propTypes } from 'formsy-react';
import _ from 'lodash';
import withFormsyValidations from '../withFormsyValidations';

class EmailInput extends React.Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      className: PropTypes.string,
      setValue: PropTypes.func.isRequired,
      required: PropTypes.bool,
      pattern: PropTypes.string,
      maxLength: PropTypes.string,
      minLength: PropTypes.string,
      disabled: PropTypes.bool,
      onChange: PropTypes.func.isRequired,
      ...propTypes,
    };
  }

  static get defaultProps() {
    return {
      required: false,
      disabled: false,
      pattern: undefined,
      maxLength: undefined,
      minLength: undefined,
      className: '',
    };
  }

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    const { name, setValue, onChange } = this.props;
    const { value } = event.currentTarget;
    setValue(value, false); // this is the performance thief
    onChange(name, value);
  }

  render() {
    // Dont remove onChange from below.
    const {
      value,
      name,
      id,
      className,
      errorMessage,
      isValid,
      required,
      disabled,
      pattern,
    } = this.props;

    return (
      <div>
        <Input
          invalid={!isValid}
          type="email"
          id={id}
          className={className}
          required={required}
          disabled={disabled}
          value={value || ''}
          name={name}
          pattern={pattern}
          onChange={this.changeValue}
        />
        <span>{errorMessage}</span>
      </div>
    );
  }
}

function isValidateEmail(email) {
  // https://www.icann.org/en/system/files/files/ua-factsheet-a4-17dec15-en.pdf
  // eslint-disable-next-line no-useless-escape
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,63})+$/.test(email)) {
    return true;
  }
  return false;
}

export default withFormsyValidations(EmailInput, props => ({
  email(values, value) {
    if (!value) return true;
    if (props.allowMultiple) {
      const emails = value.split(/[;]+/).map(_.trim);
      return _.every(emails, isValidateEmail);
    }
    return isValidateEmail(value);
  },
}));
